<template>
  <div class="pa-7" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
 <div class="row">
<v-col
      xs="12"
      sm="12"
      md="7"
      lg="7"
      xl="7"
>
 <v-card-text class="summary">
                {{ description }}
          </v-card-text>
          </v-col>
<v-col
      xs="12"
      sm="12"
      md="5"
      lg="5"
      xl="5">
              <v-img :src="src"></v-img>
              </v-col>
</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: '弊社の全文検索システムは、e-Learningシステム、技術資料や論文等、様々なシステムに組み込み可能です。弊社のe-Learningシステム、会議システムや、企業や研究所での技術資料や、論文、国立大学医学部様の会議システムの全文検索システムとして利用されています。',
      // 画像
      src: require('../../assets/Products/search.png')
    }
  }
}
</script>
